import $ from 'jquery';

export default class AnimateTitle {
  constructor(el) {
    this.el = el;

    $(window).on('load', function () {
      const title = el.querySelector('[data-animate]');
      const image = el.querySelector('[data-image]');
      const overlay = el.querySelector('[data-overlay]');
      const elementHeight = title.offsetHeight;
      let offsetPos = image.offsetHeight / 2 + elementHeight;

      if (window.innerWidth >= 1024) {
        title.classList.remove('lg:opacity-0', 'lg:white');
        overlay.classList.remove('opacity-30');
        overlay.style.opacity = 0.3;
        title.style.color = 'rgba(255, 255, 255)';
        title.style.transform = `translateY(-${offsetPos}px)`;
      }

      window.addEventListener('scroll', function () {
        if (window.innerWidth >= 1024) {
          title.classList.remove('lg:opacity-0', 'lg:white');

          if (offsetPos - this.window.scrollY >= 0) {
            let scrollPos = (offsetPos - this.window.scrollY) / offsetPos;
            let color = scrollPos * 255;

            title.style.color = `rgba(${color}, ${color}, ${color})`;

            title.style.transform = `translateY(-${
              offsetPos - this.window.scrollY
            }px)`;

            overlay.style.opacity = (scrollPos / 10) * 3;
          } else {
            title.style.transform = 'translateY(0px)';
            title.style.color = 'rgba(0, 0, 0)';
          }
        }
      });

      window.addEventListener('resize', function () {
        offsetPos = image.offsetHeight / 2 + elementHeight;

        if (window.innerWidth < 1024) {
          title.style = null;
        } else {
          title.style.color = 'rgba(255, 255, 255)';
          title.style.transform = `translateY(-${offsetPos}px)`;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/AnimateTitle.js